import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Target } from "lucide-react";
import { OPERATIONS } from "../lib/constants";
import { ProfileBar } from "../components/ProfileBar";
import { PageShell } from "../components/PageShell";
import { ClayButton } from "../components/ClayButton";

export default function Primaria({ profile, onReset }) {
  const navigate = useNavigate();

  const buildTarget = (op) => {
    if (op.id === "fracciones") return "/practica/fracciones";
    if (op.id === "decimales") return "/practica/decimales";
    return `/practica/${op.id}`;
  };

  return (
    <PageShell>
      <ProfileBar profile={profile} onReset={onReset} />

      <div className="mt-6">
        <ClayButton variant="ghost" onClick={() => navigate("/dashboard")} data-testid="back-btn">
          <ArrowLeft className="w-5 h-5" strokeWidth={3} />
          Volver
        </ClayButton>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="mt-2"
      >
        <div className="inline-flex items-center gap-3 rounded-full px-4 py-2 mb-4 bg-[#FFE8CC]">
          <span className="w-9 h-9 rounded-xl flex items-center justify-center bg-[#FF9500]">
            <Target className="w-5 h-5 text-white" strokeWidth={3} />
          </span>
          <span className="font-bold text-base text-[#B05A00]">Primaria</span>
        </div>

        <h2 className="font-heading text-3xl sm:text-4xl font-bold text-[#1C1C1E] mb-2">
          ¿Qué quieres practicar hoy?
        </h2>
        <p className="text-base sm:text-lg text-[#5C5C60] mb-6 sm:mb-8 max-w-xl">
          Elige una operación para comenzar.
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-testid="operations-grid">
          {OPERATIONS.map((op, i) => (
            <motion.button
              key={op.id}
              onClick={() => navigate(buildTarget(op))}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.06, type: "spring", bounce: 0.4 }}
              whileHover={{ y: -4 }}
              whileTap={{ scale: 0.97 }}
              className="clay-btn group relative rounded-[2rem] p-5 sm:p-6 text-left text-white border-b-[8px] active:border-b-0 overflow-hidden"
              style={{ backgroundColor: op.color, borderBottomColor: op.borderDark }}
              data-testid={`operation-card-${op.id}`}
            >
              <div className="flex items-start justify-between mb-3 sm:mb-4">
                <div
                  className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-white/25 backdrop-blur flex items-center justify-center font-heading text-3xl sm:text-4xl font-bold"
                  aria-hidden="true"
                >
                  {op.symbol}
                </div>
                <span className="text-xs font-bold uppercase tracking-wider bg-white/25 px-2 py-1 rounded-full">
                  {profile.stats.perOperation?.[op.id]?.rounds || 0} rondas
                </span>
              </div>
              <h3 className="font-heading text-2xl sm:text-3xl font-bold mb-1">{op.name}</h3>
              <p className="text-sm sm:text-base text-white/85">{op.description}</p>
            </motion.button>
          ))}
        </div>
      </motion.div>
    </PageShell>
  );
}
